export enum ETaskTabs {
  USERS = 1, // Не начат
  SETTINGS = 2, // Немного отстает
  FILES = 3 // Сильно отстает
}
